import Vue from 'vue'

const DETAIL_FETCH_ERROR_TITLE = 'データ取得に失敗しました。'
const DETAIL_UPDATE_ERROR_MESSAGE = '恐れ入りますが、時間を置いて再度お試しください。'

/**
 * X 競合一覧機能のエラートースト出し分けフック。
 */
export function useNotify() {
  const handleApiNotify = (): void => {
    return notify('danger', DETAIL_FETCH_ERROR_TITLE, DETAIL_UPDATE_ERROR_MESSAGE)
  }

  const handleCustomErrorNotify = (title: string, message?: string): void => {
    return notify('danger', title, message)
  }

  const handleSuccessNotify = (title: string, message?: string): void => {
    return notify('success', title, message)
  }

  return { handleApiNotify, handleCustomErrorNotify, handleSuccessNotify }
}

/**
 * 共通通知関数（hooks用）
 */
const notify = (type: 'danger' | 'success', title: string, message?: string): void => {
  const defaultNotify = {
    title: title,
    customClass: type,
    duration: 5000
  }

  if (message) {
    return Vue.prototype.$notify({ ...defaultNotify, message })
  }

  return Vue.prototype.$notify(defaultNotify)
}
